import { render, staticRenderFns } from "./HostVestInfo.vue?vue&type=template&id=63815856&scoped=true"
import script from "./HostVestInfo.vue?vue&type=script&lang=js"
export * from "./HostVestInfo.vue?vue&type=script&lang=js"
import style0 from "./HostVestInfo.vue?vue&type=style&index=0&id=63815856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63815856",
  null
  
)

export default component.exports